/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */

import React from 'react'
import { GetDisplayRestockHistory_displayRestockHistory_results_inventoryAfter } from '@dai/graphql'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import ProductColumns from './ProductRows'

type InventoryListProps = {
  inventory: GetDisplayRestockHistory_displayRestockHistory_results_inventoryAfter[]
}

const InventoryList: React.FC<InventoryListProps> = (
  props: InventoryListProps,
) => {
  const { inventory } = props
  return (
    <TableContainer>
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Image</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Quantity</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {inventory.map(i => (
            <ProductColumns
              upc={i.upc}
              columnsFromProduct={['marketingImageUrl', 'name']}
              additionalColumnValues={[i.quantity]}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default InventoryList
